import script from "./Sort.vue?vue&type=script&setup=true&lang=js"
export * from "./Sort.vue?vue&type=script&setup=true&lang=js"

import "./Sort.vue?vue&type=style&index=0&id=6338737a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6338737a"]])

export default __exports__